export default __webpack_public_path__ + "static/media/smeta.9f58e74d.svg";